import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {findIndex} from '@shared/helpers/array'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {
    setIndividuallyInputOption,
    setParticularInput,
    setParticularInputOption,
    getInitialState,
    AdditionalOptionState,
} from '@web/slices/additionalOption/slice'

import type {AdditionalOptionReducers, MakeCreateSliceOptions} from './interfaces'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<
        AdditionalOptionState,
        AdditionalOptionReducers,
        'additionalOption',
        SliceSelectors<AdditionalOptionState>
    >({
        name: 'additionalOption',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(setParticularInput, (state, {payload}) => {
                    state.selected.isParticularInput = payload
                })
                .addCase(setIndividuallyInputOption, (state, {payload: {name, value, exposeOrder}}) => {
                    const idx = findIndex(
                        ({name: optionName, exposeOrder: optionExposeorder}) =>
                            name === optionName && exposeOrder === optionExposeorder,
                        state.selected.individuallyInput,
                    )

                    if (state.selected.individuallyInput[idx]) {
                        state.selected.individuallyInput[idx].value = value
                    }
                })
                .addCase(setParticularInputOption, (state, {payload: {itemId, name, value, exposeOrder}}) => {
                    if (!state.selected.particularInputByItemId[itemId]) {
                        state.selected.particularInputByItemId[itemId] = []
                    }
                    const idx = findIndex(
                        ({name: optionName, exposeOrder: optionExposeorder}) =>
                            name === optionName && exposeOrder === optionExposeorder,
                        state.selected.particularInputByItemId[itemId],
                    )

                    if (state.selected.particularInputByItemId[itemId][idx]) {
                        state.selected.particularInputByItemId[itemId][idx].value = value
                    }
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.additionalOption ?? state
            })
        },
    })
